import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    // clientId: "0f9fdf1d-9670-4699-b058-e57134646514", // Your Azure AD App Client ID
    clientId: "e9ecd24d-fe06-438f-b122-42cdbe3ca265", // Your Azure AD App Client ID
    authority:
      "https://login.microsoftonline.com/8fc4e1fa-7762-4e49-bc2e-641d8a6d7530", // Use 'common' or replace with your tenant ID
    redirectUri:
      window.location.hostname === "localhost"
        ? "http://localhost:6012/login"
        // : "https://scope3-qcpanel.testgrowindigo.co.in/login",
        : "https://fytomax-s3-qc-dashboard.growindigo.co.in/login",
    // Ensure this is registered in Azure
    postLogoutRedirectUri: "/", // Redirect after logout
    navigateToLoginRequestUrl: false, // Prevents redirect loops
  },
  cache: {
    cacheLocation: "sessionStorage", // sessionStorage is more secure than localStorage
    storeAuthStateInCookie: false, // Set to true if using IE/Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

// Login request with necessary scopes
export const loginRequest = {
  scopes: ["User.Read"], // Required scopes for authentication
};

// Optional: Silent login request for SSO
export const silentRequest = {
  scopes: ["openid", "profile", "email"],
  forceRefresh: false, // Set to true to bypass cache
};

